// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-g"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 5H8.5C8.22386 5 8 5.22386 8 5.5V18.5C8 18.7761 8.22386 19 8.5 19H16V12H12.8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersGIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-g',
    ref,
    icon: element,
  },
));

LettersGIcon.displayName = 'LettersGIcon';

export default LettersGIcon;
